// extracted by mini-css-extract-plugin
export default {"wrapper":"a85cC","spinner":"Cyav4"};